import classNames from 'classnames'
import React from 'react'

// Domains
import LAYOUT_TYPES from '@src/quince-site-common/src/constants/layoutTypes'
import POSITIONS from '@src/quince-site-common/src/constants/positions'
import type ContentfulProductMeasuringGuide from '@src/quince-site-common/src/domains/contentful/ContentfulMeasuringGuide'
import ImageDomain from '@src/quince-site-common/src/domains/Image'
import RichTextDomain from '@src/quince-site-common/src/domains/RichText'

// Components
import { RichText as RichTextC } from '../../../../molecules'
import ImageC from '../../../image'

// Styles
import styles from './measuringGuide.module.scss'

export interface MeasuringGuideProps {
  measuringGuide: ContentfulProductMeasuringGuide
  showTitle?: boolean
  measuringGuideWrapperClassName?: string
  imageWrapperClassName?: string
}

const MeasuringGuide = (props: MeasuringGuideProps) => {
  const {
    measuringGuideContentRichTextPropsDesktop,
    measuringGuideContentRichTextPropsMobile,
    measuringGuideTitleRichTextProps,
  } = getContentRichTextProps(props.measuringGuide)

  return (
    <div className={classNames(styles.measuringGuideContainer, props.measuringGuideWrapperClassName)}>
      {props.showTitle && <RichTextC className={styles.measuringGuideTitle} {...measuringGuideTitleRichTextProps} />}
      <div
        className={classNames(
          styles.measuringGuideWrapper,
          props.measuringGuide.position === POSITIONS.BOTTOM && styles.measuringGuideWrapper__bottomPosition,
        )}
      >
        <div className={classNames(styles.measuringGuideWrapper__measuringGuideContentWrapper, styles.desktopOnly)}>
          {measuringGuideContentRichTextPropsDesktop && <RichTextC {...measuringGuideContentRichTextPropsDesktop} />}
        </div>

        <div className={classNames(styles.measuringGuideWrapper__measuringGuideContentWrapper, styles.mobileOnly)}>
          {measuringGuideContentRichTextPropsMobile && <RichTextC {...measuringGuideContentRichTextPropsMobile} />}
        </div>

        {props.measuringGuide.images?.[0] && (
          <div
            className={classNames(
              styles.measuringGuideWrapper__measuringGuideImageWrapper,
              props.imageWrapperClassName,
              props.measuringGuide.layoutType === LAYOUT_TYPES.CENTER &&
                styles.measuringGuideWrapper__measuringGuideImageWrapper__centeredLayout,
            )}
          >
            <div className={styles.desktopOnly}>
              <ImageC
                {...ImageDomain.fromContentful(props.measuringGuide.images[0])}
                alt={props.measuringGuide.images[0]?.title || ''}
              />
            </div>

            <div className={styles.mobileOnly}>
              <ImageC
                {...ImageDomain.fromContentful(props.measuringGuide.images[1] || props.measuringGuide.images[0])}
                alt={props.measuringGuide.images[1]?.title || props.measuringGuide.images[0]?.title || ''}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

const getContentRichTextProps = (measuringGuide: ContentfulProductMeasuringGuide) => {
  const measuringGuideContentDesktop = measuringGuide?.richTexts?.[1]
    ? RichTextDomain.fromContentful(measuringGuide.richTexts[1])
    : undefined
  const measuringGuideContentRichTextPropsDesktop = RichTextDomain.makeRichTextProps(measuringGuideContentDesktop)

  const mobileRichText = measuringGuide?.richTexts?.[3] ?? measuringGuide?.richTexts?.[1]
  const measuringGuideContentMobile = mobileRichText ? RichTextDomain.fromContentful(mobileRichText) : undefined
  const measuringGuideContentRichTextPropsMobile = RichTextDomain.makeRichTextProps(measuringGuideContentMobile)

  const measuringGuideTitle = measuringGuide?.richTexts?.[0]
    ? RichTextDomain.fromContentful(measuringGuide.richTexts[0])
    : undefined
  const measuringGuideTitleRichTextProps = RichTextDomain.makeRichTextProps(measuringGuideTitle)

  return {
    measuringGuideContentRichTextPropsDesktop,
    measuringGuideContentRichTextPropsMobile,
    measuringGuideTitleRichTextProps,
  }
}

export default MeasuringGuide
